/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OralHygiene/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OralHygiene({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Reporting/Content/OralHygiene"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let statisticsOralHygieneColorValueData = fromData.useDataValue({ viewPath,
context: 'statistics',
path: 'oral_hygiene_color',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="OralHygiene.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2fhnmw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Oral hygiene:"
 fontSize={dtTypographyFontsizeM}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral700}
/>
<div
  data-testid="OralHygiene.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-2-2fhnmw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-3-2fhnmw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--w-4-2fhnmw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-2fhnmw': statisticsOralHygieneColorValueData}}
 className={`views-block ${styles.Horizontal1}`}
/>
</div>
{children}
</React.Fragment>)
}